'use client';

import { Loader2 } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <img
          src="/logo.svg"
          alt="Giglan"
          className="h-8 w-auto"
        />
        <Loader2 className="h-6 w-6 animate-spin text-[#F46922]" />
      </div>
    </div>
  );
}



